module.exports = __webpack_public_path__ + "static/media/find-a-way.3526b646.mp3";